<template>
  <CardRow
    :label="label"
    :value="value"
    :disabled="disabled"
    :error-messages="errorMessages"
    :required="required"
    :hideBorderBottom="hideBorderBottom"
  >
    <UITextArea
      v-model="dataValue"
      hide-details
      :errorMessages="errorMessages"
      :placeholder="placeholder"
      :disabled="disabled"
      :type="type"
      :readonly="readonly"
      @change="change"
      @input="input"
    />
  </CardRow>
</template>

<script>
import CardRow from './CardRow'
import UITextArea from '../UITextArea'

export default {
  name: 'CardTextAreaRow',

  props: {
    label: String,
    value: {
      type: String | Number | null | undefined,
      default: ''
    },
    type: {
      String,
      default: 'text'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: Array
    },
    required: {
      type: Boolean,
      default: false
    },
    hideBorderBottom: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Введите значение'
    }
  },

  components: {
    UITextArea,
    CardRow
  },

  data: () => {
    return {
      dataValue: null
    }
  },

  methods: {
    change(val) {
      this.$emit('change', val)
    },
    input(val) {
      this.$emit('input', val)
    }
  },

  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.dataValue = val
      }
    }
  }
}
</script>

<style scoped></style>
